import axios from 'axios';
import { AuthenticationClient } from '../authentication/client';
import { GetUsersFunction, UserToShare } from './modals';

interface UserInfo {
  userId: string;
  givenName?: string | null;
  familyName?: string | null;
  email?: string | null;
  country?: string;
}

interface UsersByAccessResponse {
  sameAccessUsers: UserInfo[];
  otherClientUsers: UserInfo[];
}

const mapToUserToShare = (user: UserInfo): UserToShare => ({
  userId: user.userId,
  email: user.email,
  givenName: user.givenName,
  familyName: user.familyName,
});

export const getUsers: GetUsersFunction = async () => {
  const token = await AuthenticationClient.getInstance().getAccessToken();

  const result = await axios.get<UsersByAccessResponse>('/api/users-api/v1/users/users-by-access', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return result.data.sameAccessUsers.concat(result.data.otherClientUsers).map(mapToUserToShare);
};
